import { GET_AUTOMOBILE_IMAGES, REMOVE_AUTOMOBILE_IMAGES } from '../../types';

const initialState = { images: [] };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_AUTOMOBILE_IMAGES:
            return {
                ...state,
                images: [...payload]
            };
        case REMOVE_AUTOMOBILE_IMAGES:
            return {
                ...state,
                images: []
            };
        default:
            return state;
    }
}